/**
 * SessionMilestoneTracker
 *
 * Mounts useSessionDurationMilestones at App scope so the 30s / 2m / 10m
 * timers span the whole authenticated session and are not reset by
 * route-level remounts of <DashboardLayout>.
 */

import React from "react";
import { useAuth } from "../contexts/AuthContext";
import useSessionDurationMilestones from "../hooks/useSessionDurationMilestones";

const SessionMilestoneTracker: React.FC = () => {
  const { isAuthenticated } = useAuth();
  useSessionDurationMilestones(isAuthenticated);
  return null;
};

export default SessionMilestoneTracker;
